// update along with app/lib/enums/brand_cleanup_enums.py
const suggestedActions = {
  NOT_MAPPED: 'NOT_MAPPED',
  KEEP: 'KEEP',
  DETACH: 'DETACH',
  REVIEW: 'REVIEW',
};

const suggestedActionsOptions = [
  { value: suggestedActions.NOT_MAPPED, label: 'Not Mapped' },
  { value: suggestedActions.KEEP, label: 'Keep' },
  { value: suggestedActions.DETACH, label: 'Detach' },
  { value: suggestedActions.REVIEW, label: 'Review' },
];

const brandCleanupUserActions = {
  KEEP_CURRENT_BRAND: 'KEEP_CURRENT_BRAND',
  DETACH_CURRENT_BRAND: 'DETACH_CURRENT_BRAND',
  ASSIGN_SUGGESTED_BRAND: 'ASSIGN_SUGGESTED_BRAND',
  ASSIGN_SELECTED_BRAND: 'ASSIGN_SELECTED_BRAND',
  APPROVE_TRAINEE_SUGGESTED_ACTION: 'APPROVE_TRAINEE_SUGGESTED_ACTION',
  NEED_DP_ASSISTANCE: 'NEED_DP_ASSISTANCE',
  MARK_AS_NON_BRANDED: 'MARK_AS_NON_BRANDED',
};

const brandCleanupUserActionsOptions = [
  { value: brandCleanupUserActions.KEEP_CURRENT_BRAND, label: 'Keep Current Brand' },
  { value: brandCleanupUserActions.DETACH_CURRENT_BRAND, label: 'Detach Current Brand' },
  { value: brandCleanupUserActions.ASSIGN_SUGGESTED_BRAND, label: 'Assign Suggested Brand' },
  { value: brandCleanupUserActions.ASSIGN_SELECTED_BRAND, label: 'Assign Selected Brand' },
  {
    value: brandCleanupUserActions.APPROVE_TRAINEE_SUGGESTED_ACTION,
    label: 'Approve Trainee Suggested Action',
  },
  {
    value: brandCleanupUserActions.NEED_DP_ASSISTANCE,
    label: 'Need DP Assistance',
  },
  {
    value: brandCleanupUserActions.MARK_AS_NON_BRANDED,
    label: 'Mark as Non-Branded',
  },
];

export {
  suggestedActions,
  suggestedActionsOptions,
  brandCleanupUserActions,
  brandCleanupUserActionsOptions,
};
